module.exports = __webpack_public_path__ + "static/howItWork-1-bc5899e1fc943d1f6a0b2fff393f7ea3.svg";